const selectAssignmentDetailsExperimentById = (state, experimentId) => state.assignment_details_data.experiments[experimentId];
const selectAssignmentDetailsByFeatureId = (state, featureId) => state.assignment_details_data.features[featureId];
export {
  selectAssignmentDetailsByFeatureId,
  selectAssignmentDetailsExperimentById
};
//# sourceMappingURL=selectors.js.map
